module.exports = __webpack_public_path__ + "img/casino.86a0065a.svg";